import z from 'zod'
import { decimalSchema } from '../../utils/schema'

/** Backpack `FundingPayment` レスポンススキーマ */
export const fundingPaymentSchema = z.object({
  /** 対象 user ID */
  userId: z.number(),
  /** 対象 subaccount ID */
  subaccountId: z.number().nullish(),
  /** 対象 perp market シンボル (例: SOL_USDC_PERP) */
  symbol: z.string(),
  /** 支払い数量 (受取は正 / 支払いは負) */
  quantity: decimalSchema,
  /** ファンディング間隔の終了時刻 (naive ISO date-time) */
  intervalEndTimestamp: z.string(),
  /** その間隔のファンディングレート */
  fundingRate: decimalSchema,
})

export const fundingPaymentsResponseSchema = z.array(fundingPaymentSchema)

export type FundingPayment = z.infer<typeof fundingPaymentSchema>
